import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Flutter = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Why Flutter</h1>
          <p>Whether you are new to application design or an experienced application designer, a Flutter course gives you tools to expand your skill set. The platform is easy to learn and use and is growing in popularity among app developers.
            Join millions in learning Flutter from real world professionals on Udemy. Learn through our all-inclusive syllabus with adequate practical experiences to develop the easy to manage Applicaitons. Our trainers are skilled and
            have the industry experience to handle classes as per the student’s proficiency. We assist you for the assured placement after the successful course completion with valuable certification at Acrosys Technologies.</p>
          <p>
            <b>Session 1: Introduction to Flutter</b>
          </p><p>Introduction and setup</p>
          <b>Session 2: Introduction to Dart</b>
          <p>Datatypes,Conditional,loops,arrays,funcitons,OOPS,lists etc,.</p>
          <b>Session 3: Widgets</b>
          <p>Stateful, Stateless</p>
          <b>Session 4: Control Structures </b>
          <p>Container,column,row,icon,sate ,list, navigation,routing,user inputs and forms</p>
          <b>Session 5: </b>
          <p>Form Validation</p>
          <b>Session 6:Building Flutter App</b>
          <p>Material Designs,Scaffold,inkwell,gesture,bottom navigator,floting action, tab layout, fragments</p>
          <b> Session 7: Build in services</b>
          <p>Data Handling, Access Storage devices,Map - real time location,Accessing local Services</p>
          <b>Session 8: Packages and JSON</b>
          <p>intro Packages,json &amp; json Parsing,Database concepts,Accessing Rest APi</p>
          <b> Session 9: Debugging and Deployment</b>
          <p>Debugging tools, testing , inspecting UI, Build and release for Android / ios app,Deploy on App Store</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Flutter